/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindRoleQueryResponse
 */
export interface FindRoleQueryResponse {
    /**
     * Role id
     * @type {string}
     * @memberof FindRoleQueryResponse
     */
    id: string;
    /**
     * Role name
     * @type {string}
     * @memberof FindRoleQueryResponse
     */
    name: string;
    /**
     * Role status
     * @type {string}
     * @memberof FindRoleQueryResponse
     */
    status: string;
}

/**
 * Check if a given object implements the FindRoleQueryResponse interface.
 */
export function instanceOfFindRoleQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function FindRoleQueryResponseFromJSON(json: any): FindRoleQueryResponse {
    return FindRoleQueryResponseFromJSONTyped(json, false);
}

export function FindRoleQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindRoleQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'],
    };
}

export function FindRoleQueryResponseToJSON(value?: FindRoleQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': value.status,
    };
}

